// src/pages/Agents.js
import React from "react";

const agents = [
  {
    id: 1,
    name: "Yuliya Tkachuk",
    title: "Broker / Owner",
    phone: "941-718-8317",
    email: "broker@platinumpalmproperties.com",
    headshot: "/assets/agents/broker.png", // add later
    blurb:
      "Broker of Platinum Palm Properties",
  },
  {
    id: 2,
    name: "Oleg Tkachuk",
    title: "Realtor/CEO",
    phone: "941-500-4861",
    email: "ceo@platinumpalmproperties.com",
    headshot: "/assets/agents/oleg.png",
    blurb: "Sellers & Buyers Agent",
  },
  {
    id: 3,
    name: "Angelina Pitsul",
    title: "Realtor",
    phone: "916-704-4605",
    email: "angelina@platinumpalmproperties.com",
    headshot: "/assets/agents/angelina.png",
    blurb: "Sellers & Buyers Agent",
  },

];

export default function Agents() {
  return (
    <div className="container page">
      <div className="page-header">
        <div>
          <h1>Meet the Platinum Palm team</h1>
          <p>
            A small, hand-picked team focused on straight talk, clean
            marketing, and actually answering your calls.
          </p>
        </div>
      </div>

      <div className="agent-grid">
        {agents.map((agent) => (
          <article key={agent.id} className="agent-card">
            <div className="agent-photo-wrapper">
              <div className="agent-photo-fallback">
                {/* fallback initial if image not present yet */}
                {agent.name.charAt(0)}
              </div>
              <img
                src={agent.headshot}
                alt={agent.name}
                className="agent-photo"
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                }}
              />
            </div>
            <div className="agent-body">
              <h2>{agent.name}</h2>
              <p className="agent-title">{agent.title}</p>
              <p className="agent-blurb">{agent.blurb}</p>
              <div className="agent-meta">
                <p>
                  Phone:{" "}
                  <a href={`tel:${agent.phone}`} className="highlight">
                    {agent.phone}
                  </a>
                </p>
                <p>
                  Email:{" "}
                  <a href={`mailto:${agent.email}`} className="highlight">
                    {agent.email}
                  </a>
                </p>
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
